export default __webpack_public_path__ + "static/media/benefit_03.eb314c89.svg";